import * as React from 'react';

var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgParachain = function SvgParachain(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#321D47",
        d: "M0 60C0 26.863 26.863 0 60 0s60 26.863 60 60-26.863 60-60 60S0 93.137 0 60"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M60.983 47.935 49.352 74H37l17.529-33h7.83zM70.615 74 58.952 47.935 57.444 41h7.93L83 74zm-.458-12.307v6.142H45.682v-6.142z"
    })), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 97,
        r: 9,
        fill: "#E6007A"
    })), _circle2 || (_circle2 = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 23,
        r: 9,
        fill: "#E6007A"
    })), _circle3 || (_circle3 = /*#__PURE__*/ React.createElement("circle", {
        cx: 92.043,
        cy: 78.5,
        r: 9,
        fill: "#E6007A",
        transform: "rotate(-60 92.043 78.5)"
    })), _circle4 || (_circle4 = /*#__PURE__*/ React.createElement("circle", {
        cx: 27.957,
        cy: 41.5,
        r: 9,
        fill: "#E6007A",
        transform: "rotate(-60 27.957 41.5)"
    })), _circle5 || (_circle5 = /*#__PURE__*/ React.createElement("circle", {
        cx: 92.043,
        cy: 41.5,
        r: 9,
        fill: "#E6007A",
        transform: "rotate(-120 92.043 41.5)"
    })), _circle6 || (_circle6 = /*#__PURE__*/ React.createElement("circle", {
        cx: 27.957,
        cy: 78.5,
        r: 9,
        fill: "#E6007A",
        transform: "rotate(-120 27.957 78.5)"
    })));
};

export { SvgParachain as ReactComponent };
//# sourceMappingURL=Parachain.svg.es.js.map
